import {get} from 'utils/axios/index'
import {toast} from 'react-toastify'
import {DefaultApiResponse} from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {IFormField} from 'models/Common'

const fetchRejectionReasons = async (type: string) => {
 try {
  return await get<DefaultApiResponse>(
   '/common/v1/rejection-reasons',
   {type}
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const fetchFilterConfig = async (payload: IFormField) => {
 try {
  return await get<DefaultApiResponse>(
   '/common/v1/filter-config',
   payload
  ).then((res) => {
   if (res.success) {
    return res.data
   } else {
    toast.error(res.message)
    return null
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

const commonGetRequest = async <T>(
 url: string
): Promise<T | null> => {
 try {
  const res = await get<DefaultApiResponse>(url)

  if (res.success) {
   return res.data as T
  } else {
   toast.error(res.message)
   return null
  }
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export {
 fetchRejectionReasons,
 fetchFilterConfig,
 commonGetRequest,
}
